import { useState, useMemo } from "react";
import {
  Layout,
  Dropdown,
  Button,
  Avatar,
  Row,
  Col,
  Modal,
  Space,
  Card,
  Typography,
} from "antd";
import { ExpandOutlined, FullscreenOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import LS_SERVICE from "../../utils/localStorage";
import {
  getUserTypeLabel,
  HOTEL_ID_SERIES,
  isBDE,
  isVendor,
  THEME,
} from "../../constants/constent";
import assets from "../../utils/ImagesPath";

const { Header } = Layout;
const { Title, Text } = Typography;
function LayoutHeader() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  const setting = LS_SERVICE.get("setting") || {};
  const themeColor = `#${setting.theme || THEME}`;

  const user = useMemo(
    () => ({
      name: LS_SERVICE.get("name"),
      email: LS_SERVICE.get("email"),
      phone: LS_SERVICE.get("phone"),
      type: LS_SERVICE.get("user_type"),
      hotel_id: LS_SERVICE.get("hotel_id"),
      referral_code: LS_SERVICE.get("referral_code"),
      employee_code: LS_SERVICE.get("employee_code"),
    }),
    [],
  );

  /* ---------------- Fullscreen ---------------- */
  const [isFullscreen, setIsFullscreen] = useState(
    Boolean(document.fullscreenElement),
  );

  const toggleFullScreen = async () => {
    try {
      if (!isFullscreen) {
        await document.documentElement.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
      setIsFullscreen(Boolean(document.fullscreenElement));
    } catch (err) {
      console.error("Fullscreen error:", err);
    }
  };

  /* ---------------- Auth ---------------- */
  const logout = () => {
    setLoading(true);
    LS_SERVICE.login_clear();
    window.location.reload();
  };

  /* ---------------- Dropdown ---------------- */
  const dropdownItems = [
    {
      key: "profile",
      label: (
        <Button block onClick={() => setIsProfileOpen(true)}>
          Profile
        </Button>
      ),
    },
    {
      key: "logout",
      label: (
        <Button block danger loading={loading} onClick={logout}>
          Logout
        </Button>
      ),
    },
  ];

  return (
    <>
      <Header>
        <Row justify="space-between" align="middle">
          <Col span={12} />

          <Col span={12} style={{ textAlign: "right" }}>
            <Space>
              <Avatar
                shape="circle"
                style={{ backgroundColor: themeColor, cursor: "pointer" }}
                onClick={toggleFullScreen}
              >
                {isFullscreen ? <FullscreenOutlined /> : <ExpandOutlined />}
              </Avatar>

              <Dropdown menu={{ items: dropdownItems }} placement="bottomRight">
                <Avatar
                  shape="circle"
                  style={{ backgroundColor: themeColor, cursor: "pointer" }}
                  src={
                    isBDE()
                      ? assets.bdePlaceholder
                      : isVendor()
                        ? assets.vendorPlaceholder
                        : assets.profilePlaceholder
                  }
                />
              </Dropdown>
            </Space>
          </Col>
        </Row>
      </Header>

      {/* ---------------- Profile Modal ---------------- */}
      <Modal
        title=""
        open={isProfileOpen}
        onCancel={() => setIsProfileOpen(false)}
        footer={null}
        centered
        width={500}
      >
        {user && (
          <div style={{ textAlign: "center" }}>
            <Card title={user.name + ` (${getUserTypeLabel(user.type)})`}>
              <Row
                gutter={[16, 16]}
                align="middle"
                style={{ textAlign: "start" }}
              >
                <Col>
                  <Avatar
                    shape="circle"
                    style={{
                      backgroundColor: themeColor,
                      cursor: "pointer",
                      width: "120px",
                      height: "auto",
                    }}
                    src={
                      isBDE()
                        ? assets.bdePlaceholder
                        : isVendor()
                          ? assets.vendorPlaceholder
                          : assets.profilePlaceholder
                    }
                  />
                </Col>

                <Col flex="auto">
                  <Title level={5} style={{ marginBottom: 4 }}>
                    {user.name}
                  </Title>

                  {isVendor() && (
                    <>
                      <Text type="secondary">
                        <strong>HOTEL ID:</strong>{" "}
                        {HOTEL_ID_SERIES + user.hotel_id}
                      </Text>
                      <br />
                    </>
                  )}

                  {!isVendor() && (
                    <>
                      <Text type="secondary">
                        <strong>REFERRAL CODE:</strong> {user.referral_code}
                      </Text>
                      <br />
                      <Text type="secondary">
                        <strong>EMPLOYEE CODE:</strong> {user.employee_code}
                      </Text>
                    </>
                  )}

                  <br />

                  <Text type="secondary">
                    <strong>EMAIL ID:</strong> {user.email}
                  </Text>

                  <br />

                  <Text type="secondary">
                    <strong>MOBILE NO:</strong> {user.phone}
                  </Text>
                </Col>
              </Row>
            </Card>

            <Button
              type="primary"
              block
              onClick={() => navigate("/profile/update")}
            >
              Edit Profile
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
}

export default LayoutHeader;
